import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import zh from '@angular/common/locales/zh';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { provideNzI18n, zh_CN } from 'ng-zorro-antd/i18n';
import _interceptor from './api/_interceptor';
import { routes } from './app.routes';

registerLocaleData(zh);

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes),
  provideNzI18n(zh_CN),
  importProvidersFrom(FormsModule),
  provideAnimationsAsync(),
  provideHttpClient(withInterceptors([_interceptor])),
  provideIonicAngular({})]
};
